module.exports = __webpack_public_path__ + "img/code.b7e1e113.png";